import { TESTIMONIALS } from '@/mocks/home';
import Bubbles from './Bubbles';

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5 text-accent-500">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[15px]"></i>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative overflow-hidden bg-secondary-50 py-16 md:py-24">
      <Bubbles />
      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">Client Reviews</span>
          <h2 className="mt-3 font-heading text-3xl font-extrabold text-primary-800 md:text-4xl">
            What People Say About Us
          </h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-accent-500"></div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {TESTIMONIALS.map((t) => (
            <article
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-heading text-base font-bold text-primary-700">{t.name}</h3>
                <Stars count={t.stars} />
              </div>
              <p className="mt-4 flex-1 text-sm leading-relaxed text-foreground-600">&ldquo;{t.quote}&rdquo;</p>
              <a
                href="#reviews"
                className="mt-5 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-secondary-100 px-4 py-2.5 text-xs font-semibold text-secondary-900 transition-colors hover:bg-secondary-200"
              >
                <i className="ri-google-fill text-[14px] text-accent-600"></i> Review us on Google!
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}